import React, { lazy } from "react";
import DashboardLayout from "layout/LayoutContainers/DashboardLayout";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PaymentIcon from "@mui/icons-material/Payment";
import LogoutIcon from "@mui/icons-material/Logout";
import Download from "@mui/icons-material/Download";
import SecurityIcon from "@mui/icons-material/Security";

const SikapList = lazy(() => import("components/Dashboard/Sikaps/All Sikaps/SikapsList"));
const ViewSikap = lazy(() => import("components/Dashboard/Sikaps/View Sikap/index"));
const NewSikap = lazy(() => import("components/Dashboard/Sikaps/New Sikap/index"));
const SikapTransactionList = lazy(() =>
  import("components/Dashboard/Sikaps/SikapTransactions/SikapsTransactionList")
);
const DownloadSikaps = lazy(() => import("components/Dashboard/Download/SikapsDownload"));
const UserManagement = lazy(() => import("components/Dashboard/UserManagement"));
const ViewUser = lazy(() => import("components/Dashboard/Users/ViewUser"));
const Logout = lazy(() => import("components/Auth/Logout"));

const eoaRoutes = [
  {
    type: "title",
    title: "Sikaps",
    key: "sikaps-pages",
  },
  {
    type: "collapse",
    name: "Add New Sikap",
    key: "/sikaps/add",
    route: "/sikaps/add",
    component: (
      <DashboardLayout>
        <NewSikap />
      </DashboardLayout>
    ),
    noCollapse: true,
    icon: <PostAddIcon />,
  },
  {
    type: "collapse",
    name: "All Sikaps",
    key: "/sikaps/all",
    route: "/sikaps/all",
    component: (
      <DashboardLayout>
        <SikapList key="all" type="all" />
      </DashboardLayout>
    ),
    noCollapse: true,
    icon: <FormatListBulletedIcon />,
  },
  {
    type: null,
    route: "/sikaps/view/:id",
    key: "/sikaps/view/:id",
    component: (
      <DashboardLayout>
        <ViewSikap />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-5" },
  {
    type: "title",
    title: "Transactions",
    key: "transaction-pages",
  },
  {
    type: "collapse",
    name: "Sikaps Transactions",
    key: "/sikaps/transaction/all",
    route: "/sikaps/transaction/all",
    component: (
      <DashboardLayout>
        <SikapTransactionList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-dl" },
  {
    type: "title",
    title: "Download",
    key: "download-eo",
  },
  {
    type: "collapse",
    name: "Sikaps Report",
    key: "/download/sikaps",
    route: "/download/sikaps",
    component: (
      <DashboardLayout>
        <DownloadSikaps />
      </DashboardLayout>
    ),
    icon: <Download />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-mgmt" },
  {
    type: "title",
    title: "Management",
    key: "management-eo",
  },
  {
    type: "collapse",
    name: "Enforcement Officer User",
    key: "/management/enforcementofficeruser",
    route: "/management/enforcementofficeruser",
    component: (
      <DashboardLayout>
        <UserManagement subType="enforcement_officer_user" />
      </DashboardLayout>
    ),
    icon: <SecurityIcon />,
    noCollapse: true,
  },
  {
    type: null,
    route: "/user/:id",
    key: "/user/:id",
    component: (
      <DashboardLayout>
        <ViewUser />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-7" },
  { type: "title", title: "Profile", key: "profile-pages" },
  {
    type: "collapse",
    route: "/auth/logout",
    name: "Logout",
    key: "logout",
    icon: <LogoutIcon />,
    component: <Logout />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-3" },
];

export default eoaRoutes;
